<script lang="ts">
    
    import { i18n } from "../../Services/i18n"

    export let text: string;

</script>

{$i18n(text)}
